/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import './editor.all.js';
import './standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js';
import './standalone/browser/inspectTokens/inspectTokens.js';
import './standalone/browser/quickAccess/standaloneHelpQuickAccess.js';
import './standalone/browser/quickAccess/standaloneGotoLineQuickAccess.js';
import './standalone/browser/quickAccess/standaloneGotoSymbolQuickAccess.js';
import './standalone/browser/quickAccess/standaloneCommandsQuickAccess.js';
import './standalone/browser/referenceSearch/standaloneReferenceSearch.js';
import './standalone/browser/toggleHighContrast/toggleHighContrast.js';

export * from './editor.api.js';
